const CourseTypeList = () => import('@/vuepage/course-manage/CourseTypeList');
const CourseLssuedList = () => import('@/vuepage/course-manage/CourseLssuedList');
const CourseList = () => import('@/vuepage/course-manage/CourseList');
const CourseDetail = () => import('@/vuepage/course-manage/components/CourseDetail');
const CourseRecList = () => import('@/vuepage/course-manage/CourseRecList');
const CourseListDialog = () => import('@/vuepage/course-manage/CourseListDialog');

export default [{
		path: '/course-type-list',
		component: CourseTypeList,
		meta: [{
				name: '课程管理'
			},
			{
				name: '课程分类管理',
				activeRoute: '/course-type-list'
			}
		]
	},
	{
		path: '/course-lssued-list',
		component: CourseLssuedList,
		meta: [{
				name: '课程管理'
			},
			{
				name: '课程下发管理',
				activeRoute: '/course-lssued-list'
			}
		]
	},
	{
		path: '/course-list',
		component: CourseList,
		meta: [{
				name: '课程管理'
			},
			{
				name: '课程列表',
				activeRoute: '/course-list'
			}
		]
	},
	{
		path: '/course-list-dialog',
		component: CourseListDialog,
		meta: [{
				name: '课程管理'
			},
			{
				name: '课程列表',
				activeRoute: '/course-list'
			},
			{
				name: '新增/编辑课程',
				activeRoute: '/course-list-dialog'
			}
		]
	},
	{
		path: '/course-detail',
		component: CourseDetail,
		meta: [{
				name: '课程管理'
			},
			{
				name: '课程列表',
				activeRoute: '/course-list'
			},
			{
				name: '课程详情',
				activeRoute: '/course-detail'
			}
		]
	},
	{
		path: '/course-rec-list',
		component: CourseRecList,
		meta: [{
				name: '课程管理'
			},
			{
				name: '课程推荐管理',
				activeRoute: '/course-rec-list'
			},
		]
	},

];